export default __webpack_public_path__ + "static/media/ic-circleclose.90c9f921.svg";